import React from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from '../../assets/MALogo.svg'


const ThankYou = ({ subType, amount, expirationDate, invoiceId }) => {
  const navigate = useNavigate();

  return (
    <div className='d-flex justify-content-center my-5'>
      <div className="rounded p-5 col-10 col-md-6" style={{ backgroundColor: "#0B0E1E", border: "1px solid #E5E5E5" }}>
          <h2 className="text-center mb-4">Thank you for your purchase!</h2>
          <p className='mb-2'>Your payment was successful, and you now have access to the Melee Academy Foundations Course.</p>
          <p><b>Invoice ID:</b> {invoiceId}</p>
          <p><b>Subscription Type:</b> {subType === "1MF" ? "1 Month Access" : subType === "2MF" ? "2 Month Access" : "3 Month Access"}</p>
          <p><b>Amount Paid:</b> ${amount} USD</p>
          <p><b>Expiration Date:</b> {expirationDate}</p>
          <hr></hr>
          <p>If you have any questions or need assistance, please check out <a href="https://meleeacademy.com/support">Help & Support</a> page for more information.</p>
          <div className="text-center mt-3">
              <button className="rounded" style={{backgroundColor: "#FFCC19", width: "175px", height: "45px", fontWeight: 600}} onClick={() => navigate('/tutorials/foundation')}>Go to Tutorials</button>
          </div>
      </div>
    </div>
  )
}

export default ThankYou